export const ACCOUNTS_PERMS = {
  CUSTOMER_READ: 'ACCOUNTS_CUSTOMER_READ',
  CUSTOMER_CREATE: 'ACCOUNTS_CUSTOMER_CREATE',
  CUSTOMER_UPDATE: 'ACCOUNTS_CUSTOMER_UPDATE',
  CUSTOMER_DELETE: 'ACCOUNTS_CUSTOMER_DELETE',

  DASHBOARD_READ: 'ACCOUNTS_DASHBOARD_READ',

  QUOTE_READ: 'ACCOUNTS_QUOTE_READ',
  QUOTE_CREATE: 'ACCOUNTS_QUOTE_CREATE',
  QUOTE_UPDATE: 'ACCOUNTS_QUOTE_UPDATE',
  QUOTE_DELETE: 'ACCOUNTS_QUOTE_DELETE',

  SALES_ORDER_READ: 'ACCOUNTS_SALES_ORDER_READ',
  SALES_ORDER_CREATE: 'ACCOUNTS_SALES_ORDER_CREATE',
  SALES_ORDER_UPDATE: 'ACCOUNTS_SALES_ORDER_UPDATE',
  SALES_ORDER_DELETE: 'ACCOUNTS_SALES_ORDER_DELETE',

  INVOICE_READ: 'ACCOUNTS_INVOICE_READ',
  INVOICE_CREATE: 'ACCOUNTS_INVOICE_CREATE',
  INVOICE_UPDATE: 'ACCOUNTS_INVOICE_UPDATE',
  INVOICE_DELETE: 'ACCOUNTS_INVOICE_DELETE',

  RECURRING_INVOICE_READ: 'ACCOUNTS_RECURRING_INVOICE_READ',
  RECURRING_INVOICE_CREATE: 'ACCOUNTS_RECURRING_INVOICE_CREATE',
  RECURRING_INVOICE_UPDATE: 'ACCOUNTS_RECURRING_INVOICE_UPDATE',
  RECURRING_INVOICE_DELETE: 'ACCOUNTS_RECURRING_INVOICE_DELETE',

  DELIVERY_CHALLAN_READ: 'ACCOUNTS_DELIVERY_CHALLAN_READ',
  DELIVERY_CHALLAN_CREATE: 'ACCOUNTS_DELIVERY_CHALLAN_CREATE',
  DELIVERY_CHALLAN_UPDATE: 'ACCOUNTS_DELIVERY_CHALLAN_UPDATE',
  DELIVERY_CHALLAN_DELETE: 'ACCOUNTS_DELIVERY_CHALLAN_DELETE',

  PAYMENT_RECEIVED_READ: 'ACCOUNTS_PAYMENT_RECEIVED_READ',
  PAYMENT_RECEIVED_CREATE: 'ACCOUNTS_PAYMENT_RECEIVED_CREATE',
  PAYMENT_RECEIVED_UPDATE: 'ACCOUNTS_PAYMENT_RECEIVED_UPDATE',
  PAYMENT_RECEIVED_DELETE: 'ACCOUNTS_PAYMENT_RECEIVED_DELETE',

  CREDIT_NOTE_READ: 'ACCOUNTS_CREDIT_NOTE_READ',
  CREDIT_NOTE_CREATE: 'ACCOUNTS_CREDIT_NOTE_CREATE',
  CREDIT_NOTE_UPDATE: 'ACCOUNTS_CREDIT_NOTE_UPDATE',
  CREDIT_NOTE_DELETE: 'ACCOUNTS_CREDIT_NOTE_DELETE',

  VENDOR_READ: 'ACCOUNTS_VENDOR_READ',
  VENDOR_CREATE: 'ACCOUNTS_VENDOR_CREATE',
  VENDOR_UPDATE: 'ACCOUNTS_VENDOR_UPDATE',
  VENDOR_DELETE: 'ACCOUNTS_VENDOR_DELETE',

  EXPENSE_READ: 'ACCOUNTS_EXPENSE_READ',
  EXPENSE_CREATE: 'ACCOUNTS_EXPENSE_CREATE',
  EXPENSE_UPDATE: 'ACCOUNTS_EXPENSE_UPDATE',
  EXPENSE_DELETE: 'ACCOUNTS_EXPENSE_DELETE',

  RECURRING_EXPENSE_READ: 'ACCOUNTS_RECURRING_EXPENSE_READ',
  RECURRING_EXPENSE_CREATE: 'ACCOUNTS_RECURRING_EXPENSE_CREATE',
  RECURRING_EXPENSE_UPDATE: 'ACCOUNTS_RECURRING_EXPENSE_UPDATE',
  RECURRING_EXPENSE_DELETE: 'ACCOUNTS_RECURRING_EXPENSE_DELETE',

  PURCHASE_ORDER_READ: 'ACCOUNTS_PURCHASE_ORDER_READ',
  PURCHASE_ORDER_CREATE: 'ACCOUNTS_PURCHASE_ORDER_CREATE',
  PURCHASE_ORDER_UPDATE: 'ACCOUNTS_PURCHASE_ORDER_UPDATE',
  PURCHASE_ORDER_DELETE: 'ACCOUNTS_PURCHASE_ORDER_DELETE',

  BILL_READ: 'ACCOUNTS_BILL_READ',
  BILL_CREATE: 'ACCOUNTS_BILL_CREATE',
  BILL_UPDATE: 'ACCOUNTS_BILL_UPDATE',
  BILL_DELETE: 'ACCOUNTS_BILL_DELETE',

  RECURRING_BILL_READ: 'ACCOUNTS_RECURRING_BILL_READ',
  RECURRING_BILL_CREATE: 'ACCOUNTS_RECURRING_BILL_CREATE',
  RECURRING_BILL_UPDATE: 'ACCOUNTS_RECURRING_BILL_UPDATE',
  RECURRING_BILL_DELETE: 'ACCOUNTS_RECURRING_BILL_DELETE',

  PAYMENT_MADE_READ: 'ACCOUNTS_PAYMENT_MADE_READ',
  PAYMENT_MADE_CREATE: 'ACCOUNTS_PAYMENT_MADE_CREATE',
  PAYMENT_MADE_UPDATE: 'ACCOUNTS_PAYMENT_MADE_UPDATE',
  PAYMENT_MADE_DELETE: 'ACCOUNTS_PAYMENT_MADE_DELETE',

  VENDOR_CREDIT_READ: 'ACCOUNTS_VENDOR_CREDIT_READ',
  VENDOR_CREDIT_CREATE: 'ACCOUNTS_VENDOR_CREDIT_CREATE',
  VENDOR_CREDIT_UPDATE: 'ACCOUNTS_VENDOR_CREDIT_UPDATE',
  VENDOR_CREDIT_DELETE: 'ACCOUNTS_VENDOR_CREDIT_DELETE',

  BUDGET_READ: 'ACCOUNTS_BUDGET_READ',
  BUDGET_CREATE: 'ACCOUNTS_BUDGET_CREATE',
  BUDGET_UPDATE: 'ACCOUNTS_BUDGET_UPDATE',
  BUDGET_DELETE: 'ACCOUNTS_BUDGET_DELETE',

  VESSEL_EXPENSE_INVOICE_READ: 'ACCOUNTS_VESSEL_INVOICE_READ',
  VESSEL_EXPENSE_INVOICE_CREATE: 'ACCOUNTS_VESSEL_INVOICE_CREATE',
  VESSEL_EXPENSE_INVOICE_UPDATE: 'ACCOUNTS_VESSEL_INVOICE_UPDATE',
  VESSEL_EXPENSE_INVOICE_DELETE: 'ACCOUNTS_VESSEL_INVOICE_DELETE',
}
